export const mockVisualSearchResultsData = {
  products: [
    { asin: "B07H65KP63" },
    { asin: "B01DFKC2SO" },
    { asin: "B0863V5FMX" },
    { asin: "B071JNMQJ6" },
    { asin: "B0841V5QZM" },
  ],
};
